import type { CursorData } from '@alpod-ai-writer/shared';
import type { ExtendEditor, SlateEditor } from '@udecode/plate';

import { type PlateYjsEditorProps, withTCursors } from './withTCursors';
import { withTYHistory } from './withTYHistory';
import { withTYjs } from './withTYjs';
import type { YjsConfig } from './yjsPlugin';

export const withPlateYjs: ExtendEditor<YjsConfig> = ({
    editor: e,
    getOptions,
}) => {
    const editor = e as unknown as PlateYjsEditorProps & SlateEditor;

    const { cursorData, provider, getYjsDocumentNode, initialValue, preloadedContent } = getOptions();

    const sharedType = getYjsDocumentNode();

    if (preloadedContent) {
        editor.children = structuredClone(preloadedContent.children) as typeof editor.children;
    } else if (sharedType.length === 0 && initialValue) {
        const type = (initialValue as { type?: string }).type ?? 'p';
        editor.children = [{ type, children: [{ text: '' }] }] as typeof editor.children;
    }

    return withTYHistory(
        withTCursors<CursorData>(
            withTYjs(editor, sharedType, {
                autoConnect: false,
                synchronizeValue: !preloadedContent,
            }),
            provider.awareness!,
            {
                autoSend: true,
                data: cursorData
            }
        )
    );
};
